module.exports = __webpack_public_path__ + "img/classification3.f5594399.png";